import { ReactElement } from 'react';
import type { Column } from 'components/DataGrid';
import { textEditor } from 'components/DataGrid';
import type { GridGroup, GridSummaryRow, RowOrGroup } from '../../../types';
import { budgetTitleEditor, cellClassName, GAP } from './style.css';
import { supplierTitleHeader } from 'modules/supplier/supplier/components';
import { CellWrapper } from './CellWrapper';
import { ViewSummaryBudget } from './ViewSummaryBudget';
import { iconBtn } from '../../style.css';
import { Box, Button } from '@ff-it/ui';
import { useToggleAll } from 'modules/campaign/plan/state';
import { EditSupplier } from './EditSupplier';
import { ViewSupplier } from '../../../components/ViewSupplier';

const BASE_WIDTH = 326;
const icons = {
  expanded: 'folder-open',
  collapsed: 'folder-closed',
  mixed: 'folder-minus',
};
function TilteHeader(): ReactElement {
  const [state, toggleGroup] = useToggleAll();
  return (
    <Box display="flex" alignItems="center" gap="1" flexGrow={1} ml={state === 'no-groups' ? '2' : '0.5'}>
      {state !== 'no-groups' && (
        <Button testId="toggle-group" variant="ghost" onClick={toggleGroup} icon={icons[state]} className={iconBtn} />
      )}
      <Box flexGrow={1}>{supplierTitleHeader}</Box>
    </Box>
  );
}

const _column: Exclude<Column<RowOrGroup, GridSummaryRow>, 'width'> = {
  name: <TilteHeader />,
  key: 'title',
  frozen: true,
  headerCellClass: cellClassName,
  cell: (row) => {
    if (row._isGroup) {
      return {
        displayCellContent: false,
        className: cellClassName,
        locked: row.config.locked,
        required: false,
        empty: !row.title,
        valid: true,
        renderCell: () => (
          <CellWrapper row={row}>
            <ViewGroup row={row} />
          </CellWrapper>
        ),
        renderEditCell: (props) => (
          <CellWrapper row={row}>{textEditor({ ...props, field: 'title', className: budgetTitleEditor })}</CellWrapper>
        ),
      };
    }
    return {
      displayCellContent: false,
      className: cellClassName,
      ...row.config.supplier,
      renderCell: () => (
        <CellWrapper row={row}>
          <ViewSupplier row={row} />
        </CellWrapper>
      ),
      renderEditCell: ({ onClose }) => (
        <CellWrapper row={row}>
          <EditSupplier row={row} onClose={onClose} />
          <ViewSupplier row={row} />
        </CellWrapper>
      ),
    };
  },
  renderSummaryCell: (props) => <ViewSummaryBudget {...props} />,
};

export function createTitleColumn(maxDepth: number): Column<RowOrGroup, GridSummaryRow> {
  return {
    width: BASE_WIDTH + maxDepth * GAP,
    ..._column,
  };
}

export function ViewGroup({ row }: { row: GridGroup }): ReactElement {
  return (
    <Box flexGrow={1} display="flex" flexDirection="column" minWidth="0" lineHeight="1">
      {row.title ? row.title : <Box fontWeight="regular" color="gray500">{`Unnamed group ${row.id}`}</Box>}
    </Box>
  );
}
